import { DEFAULT_PER_PAGE_KEY } from '@/core/constants/const';
import {
	getPerPageFromUserSettings,
	updatePerPageInUserSettings,
} from '@/core/helpers/userSystemSettings';
import { nextTick, ref, watch } from 'vue';

const getInitialPerPage = (): number => {
	const fromLocalStorage = window.localStorage.getItem(DEFAULT_PER_PAGE_KEY);

	if (fromLocalStorage) {
		return +fromLocalStorage;
	}

	return getPerPageFromUserSettings();
};

export const usePagination = (
	perPageArr = [10, 30, 50, 100, 150],
	pageSize = getInitialPerPage(),
) => {
	const currentPage = ref(1);
	const totalItems = ref(0);
	const perPage = ref(pageSize ? +pageSize : 30);
	const loading = ref(false);
	const searchTerm = ref('');

	const indexDisplay = (index) => {
		return (currentPage.value - 1) * perPage.value + index + 1;
	};

	watch(searchTerm, async () => {
		await nextTick();

		if (currentPage.value !== 1) {
			currentPage.value = 1;
		}
	});

	watch(perPage, async () => {
		await nextTick();
		window.localStorage.setItem(DEFAULT_PER_PAGE_KEY, perPage.value.toString());
		updatePerPageInUserSettings(perPage.value);
	});

	const indexCal = (index: number, page = 0, perPage = 0) => {
		if (!page) return index + 1;

		return (page - 1) * perPage + index + 1;
	};

	return {
		currentPage,
		totalItems,
		searchTerm,
		perPage,
		indexCal,
		indexDisplay,
		perPageArr,
		loading,
	};
};
